module.exports = __webpack_public_path__ + "media/setType.da3dff6e.mp4";